/** Socket event names. Client → server and server → client. */
export const ClientEvent = {
    CreateTable: 'createTable',
    JoinTable: 'joinTable',
    PreviewTable: 'previewTable',
    LeaveTable: 'leaveTable',
    ChooseSeat: 'chooseSeat',
    AddBot: 'addBot',
    RemoveBot: 'removeBot',
    UpdateConfig: 'updateConfig',
    SetCoach: 'setCoach',
    /** Host, lobby only: list the table under "Open tables", or not. */
    SetListed: 'setListed',
    StartMatch: 'startMatch',
    /** After a match: "I'm in" / "I'm out" for another with the same seats. */
    RematchChoice: 'rematchChoice',
    Call: 'call',
    Decide: 'decide',
    Play: 'play',
    Ready: 'ready',
    ContributeSeed: 'contributeSeed',
    ProposeReplacement: 'proposeReplacement',
    VoteReplacement: 'voteReplacement',
    ReclaimSeat: 'reclaimSeat',
    Resume: 'resume',
    RequestSnapshot: 'requestSnapshot',
    /** A card being handled (protocol/gesture.ts). Relayed, never reduced. */
    Gesture: 'gesture',
    /** Fingers on the felt (protocol/gesture.ts). Relayed, never reduced. */
    FeltTouch: 'feltTouch',
};
export const ServerEvent = {
    Snapshot: 'snapshot',
    TablePreview: 'tablePreview',
    TableCreated: 'tableCreated',
    TableJoined: 'tableJoined',
    Error: 'gameError',
    SessionInvalid: 'sessionInvalid',
    Kicked: 'kicked',
    /** Another player handling a card (protocol/gesture.ts). */
    Gesture: 'gesture',
    /** Another player's fingers on the felt (protocol/gesture.ts). */
    FeltTouch: 'feltTouch',
};
//# sourceMappingURL=events.js.map